import { Container, Grid, Link, Typography } from "@mui/material";
import AssetList from "../AssetList/AssetList";
import Actions from "../Actions/Actions";
import Support from "../Support/Support";

import { createContext, useEffect, useMemo } from "react";
import Policies from "../Policies/Policies";
import { useGetAssignedHardwareAsync } from "./async/useGetAssignedHardwareAsync";
import { useGetAssetReplacementAsync } from "./async/useGetAssetReplacementAsync";
import { GERMANY_NAME } from "../../helper/constant";

export const AssetListContext = createContext([]);

export const AssetReplacementListContext = createContext({} as any);

export const UserDetailsContext = createContext({} as any);
export const ApiResponseOkContext = createContext(true);

export default function HardwareDetails(props) {
  const {
    isLoading: isAssignedHardwareLoading,
    error: isAssignedHardwareError,
    data: assignedHardware,
    isFetching: isAssignedHardwareFetching,
  } = useGetAssignedHardwareAsync();

  const {
    isLoading: isAssetReplacementLoading,
    error: isAssetReplacementError,
    data: assetReplacements,
    isRefetching: isAssetReplacementReFetching,
    refetch: refetchAssetReplacements,
    isFetching: isAssetReplacementFetching,
  } = useGetAssetReplacementAsync();

  const isGermanyUser = useMemo(
    () => props?.user?.workingOffice?.country === GERMANY_NAME,
    [props?.user?.workingOffice?.country]
  );

  return (
    <ApiResponseOkContext.Provider
      value={!isAssignedHardwareError || !isAssetReplacementError}
    >
      <AssetListContext.Provider
        value={assignedHardware ? assignedHardware : []}
      >
        <AssetReplacementListContext.Provider
          value={{
            assetReplacements: assetReplacements ? assetReplacements : [],
            refetchAssetReplacements: refetchAssetReplacements,
            isReplacementRequestReFetching: isAssetReplacementReFetching,
          }}
        >
          <UserDetailsContext.Provider value={props.user}>
            <Container maxWidth={false} className="hardware-app">
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography variant={"h1"} color={"primary.main"}>
                    Hardware
                  </Typography>
                  <Typography
                    variant={"body1"}
                    marginTop={"8px"}
                    marginBottom={"8px"}
                  >
                    Hey, all your hardware needs are available here.
                  </Typography>
                  <Typography
                    variant={"body1"}
                    marginTop={"8px"}
                    marginBottom={"8px"}
                  >
                    For more information about Laptops and Hardware supported by
                    GITS, please check out our {""}
                    <Link
                      color="secondary.main"
                      href={
                        "https://thoughtworks.atlassian.net/wiki/spaces/ALLGI/pages/375292296/Laptops+and+Hardware+TechOps"
                      }
                      target="_blank"
                      rel="noreferrer"
                      sx={{
                        textDecoration: "none",
                        "&:hover": {
                          fontWeight: "600",
                        },
                      }}
                    >
                      Central page.
                    </Link>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <AssetList
                    loading={
                      isAssignedHardwareLoading || isAssetReplacementLoading
                    }
                    fetching={
                      isAssignedHardwareFetching || isAssetReplacementFetching
                    }
                  />
                </Grid>
                {!isGermanyUser && (
                  <Grid item xs={12}>
                    <Actions />
                  </Grid>
                )}
                {!isGermanyUser && (
                  <Grid item xs={12}>
                    <Policies />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Support isGermanyUser={isGermanyUser} />
                </Grid>
              </Grid>
            </Container>
          </UserDetailsContext.Provider>
        </AssetReplacementListContext.Provider>
      </AssetListContext.Provider>
    </ApiResponseOkContext.Provider>
  );
}
